window.jQuery = window.$ = require('jquery');

var angular = require('angular');
var config = require('./config');
var Parse = window.Parse = require('parse');
Parse.initialize(config.parse.appid, config.parse.appkey);
Parse.serverURL = config.parse.path;
Parse.Object.disableSingleInstance();
// uncomment for offline run
//const Stripe = { setPublishableKey: function(){}}
Stripe.setPublishableKey(config.stripe.key);

angular.module('templates', [])
    .constant('error', require('./templates/error.html'));

angular.module('ikeweb.templates', []);

require('nanoscroller');
require('angulartics');
require('angulartics/src/angulartics-ga.js');
require('@ikegps/ikeweb-shared');
require('angular-translate');
require('angular-translate-loader-static-files');
require('./ike.services.logging');
require('jquery-ui/ui/widgets/droppable');
require('jquery.kinetic/jquery.kinetic.js');
require('jquery-mousewheel');
require('canvg/rgbcolor.js');
require('canvg/StackBlur.js');
require('canvg');

var app = angular.module('ikeweb', [
    'ikeweb.routes',
    'ikegps.math',
    'templates',
    'ikeweb.templates',
    'angulartics',
    'angulartics.google.analytics',
    'ikeweb.layout',
    'ikeweb.spike',
    'ikeweb.spike.measure',
    'ikeweb.spike.capture',
    'ikeweb.spike.gallery',
    'ikeweb.spike.report',
    'ikeweb.spike.sharing',
    'ikeweb.spike.step',
    'ikeweb.user',
    'ikeweb.locale',
    'ikeweb.folders',
    'ikeweb.notes',
    'ikeweb.map',
    'ikeweb.subscription',
    require('angular-local-storage'),
    'ike.services.logging',
    'ikeweb.shared.notification',
    'ikeweb.shared.input',
    'ikeweb.shared.layout',
    'ikeweb.shared.progress',
    'ikeweb.error',
    'ikeweb.shared.i18n',
    'ike.services.translations'
]);


app.config(['localStorageServiceProvider', function(localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('ikeweb');
}]);

app.config(['photogrammetryToolKitProvider', function(photogrammetryToolKitProvider) {
    photogrammetryToolKitProvider.setStyles({
        GrabHandleStroke: '#FFFFFF',
        GrabHandleActive: '#01FF70',
        MeasurementPolygonFill: '#FF4136',
        AlignmentPolygonFill: '#FFDC00',
        MeasurementCutoutFill: '#A750D3'
    });
}]);

app.run(['translationService', 'localeService', function(translationService, localeService) {
    translationService.translate(localeService.getCurrentLocale().value);
}]);

app.config(['LogEntriesProvider', function(LogEntriesProvider) {
    LogEntriesProvider.init(config.logentries.client);
}]);

app.provider('username', function() {
    return {
        $get: [
            function() {
                return {
                    get: function() {
                        var user = Parse.User.current();
                        return user ? user.getUsername() : 'not logged in';
                    }
                };
            }
        ]
    };
});

app.run(['$rootScope', '$analytics', function($rootScope, $analytics, UserService) {
    function getCurrentUser() {
        return Parse.User.current();
    }

    $rootScope.$watch(getCurrentUser, function(currentUser) {
        if (currentUser) {
            $analytics.setUsername(currentUser.id);
            $analytics.setUserProperties({
                dimension1: currentUser.id
            });
        } else {
            $analytics.setUsername(null);
        }
    });
}]);


app.value('MAP_CONFIG', {
    LOCATION: config.map.mapLocation,
    ID: config.map.mapId,
    API_KEY: config.map.apiKey,
    ATTRIBUTION: '© <a href="https://www.mapbox.com/map-feedback/"">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
    iconSize: [43, 38],
    iconAnchor: [14, 38]
});



require('./components');



//////////////////
// WEBPACK FOOTER
// ./src/client/app.js
// module id = 165
// module chunks = 0